'use client';

import { Close } from '@1debit/icons';
import { useFloatingDisclaimerDismissedTracking } from 'components/analytics/hooks/useFloatingDisclaimerDismissedTracking';
import { useFloatingDisclaimerShownTracking } from 'components/analytics/hooks/useFloatingDisclaimerShownTracking';
import Button from 'components/shared/Buttons/BaseButton';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { DisclosureBannerProps } from 'libs/contentful/props';
import { useEffect, useState } from 'react';
import { Colorways } from 'types/constants';
import { cn, getColorway } from 'utils/styles';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { usePage } from '@/contexts/PageProvider';

const DisclosureBanner = ({ sys, copy }: DisclosureBannerProps) => {
  const { visualSettings } = usePage();
  const [dismissed, setDismissed] = useState(false);
  const trackBannerDismissed = useFloatingDisclaimerDismissedTracking();
  const trackBannerShown = useFloatingDisclaimerShownTracking();

  useEffect(() => {
    trackBannerShown();
  });

  const handleClose = () => {
    setDismissed(true);
    trackBannerDismissed();

    // Dispatch custom event to notify other components
    window.dispatchEvent(new CustomEvent('disclosureBannerDismissed'));
  };

  if (dismissed) return null;

  return (
    <div
      className={cn(
        'w-full min-h-min sm:h-14 box-border',
        'shadow-kale/5 shadow-[0_-10px_20px]',
        'fixed bottom-0 right-0 z-25 ',
        getColorway(visualSettings?.pageColor ?? Colorways.Primary),
      )}
      data-disclosure-banner>
      <div
        className="content-wrapper max-sm:px-3 py-4 text-legal font-sans flex gap-3 md:gap-6 items-center justify-between h-full box-border"
        {...liveUpdateAttrs(sys?.id, 'copy')}>
        <RichTextCopy copy={copy} />
        <div className="flex">
          <Button variant="icon" label="Close" onClick={handleClose} className={'p-1'}>
            <Close />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DisclosureBanner;
